import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class DeleteMailchimpVendorCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IDeleteMailchimpVendorParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'vendor/mailchimp/{userId}';
  public override setParameters(parameters: IDeleteMailchimpVendorParameters) {
    this._commandUrl = this._commandUrl.replace('{userId}', parameters.userId.toString());
  }
}

export interface IDeleteMailchimpVendorParameters extends ICommandParameters {
  userId: string;
}
